<div class="kontainer">
  <avatar [medlem]="medlem()" [stil]="avatarStil()"/>

  @if(medlem().anonymisert){
    <div class="informasjon">
      <p class="navn e2e-navn">{{medlem().navn}}</p>
      <p class="tilgang e2e-anonymisert">{{ 'Deaktivert {dato}'|translate:{dato: medlem().medlemstatusSistEndret|zoneddatetime} }}</p>
      <p class="tilgang" matTooltip="{{'Epost og telefonnummer har blitt fjernet og medlemmet kan ikke reaktiveres'}}">
        <i class="ion-ios-information-outline"></i>
        {{'Dette medlemmet har blitt permanent deaktivert'}}
      </p>
    </div>

  } @else {
    <div class="informasjon">
      <p class="navn e2e-navn">{{medlem().navn}}</p>
      <p class="roller e2e-rolle">
      @for (rolle of medlem().aktiveMedlemsroller; track rolle.id) {
        <div [matTooltip]="rolle.periode|datoperiodeutentid">{{ rolle.tittel }}</div>
      }
      </p>

      @if (!medlem().harTilgang) {
        <p class="tilgang e2e-tilgang-stengt">{{ 'Tilgang stengt {dato}'|translate:{dato: medlem().medlemstatusSistEndret|zoneddatetime} }}</p>
      }

      @if (medlem().mobilnummer) {
        <p class="mobilnummer">
          <a href="tel:{{medlem().mobilnummer}}">
            <i class="ion-ios-telephone-outline"></i> {{medlem().mobilnummer | mobilnummer}}
          </a>
        </p>
      }

      <p class="epost e2e-epost">
        <a href="mailto:{{medlem().epost}}">
          <i class="ion-ios-email-outline"></i> {{medlem().epost}}
        </a>
      </p>

      <p class="i18nvalg">
        <tittel-verdi-samling stil="horisontal">
          <tittel-verdi>
            <tittel><i class="ion-ios-world-outline"></i></tittel>
            <verdi><lokale [lokale]="medlem().spraak"/></verdi>
          </tittel-verdi>
          <tittel-verdi>
            <tittel><i class="ion-ios-time-outline"></i></tittel>
            <verdi><tidssone [tidssone]="medlem().tidssone"/></verdi>
          </tittel-verdi>
        </tittel-verdi-samling>
      </p>
    </div>
  }
</div>

